<template>
  <footer
    v-if="!whitelabel"
    class="block py-4"
  >
    <div class="container mx-auto px-4">
      <hr class="border-b-[0.5] mb-4 border-slate-200">
      <div
        class="flex flex-wrap items-center justify-center xl:justify-between"
      >
        <div class="w-full px-2 xl:w-4/12">
          <div
            class="py-1 text-center text-sm font-semibold text-slate-500 dark:text-slate-300 xl:text-left"
          >
            © {{ date }} Rack Manage. All rights reserved.
          </div>
        </div>
        <div class="w-full px-2 xl:w-8/12">
          <ul class="m-0 flex list-none flex-wrap justify-center xl:justify-end">
            <li>
              <a
                href="https://support.rackmanage.io/"
                class="footer-link"
              >
                Help
              </a>
            </li>
            <li>
              <a
                href="https://rackmanage.featurebase.app/?createPost=true"
                class="footer-link"
              >
                Feedback
              </a>
            </li>
            <li>
              <button
                id="report-bug-button"
                class="footer-link bg-transparent"
              >
                Report Bug
              </button>
            </li>
            <a-dropdown
              :trigger="['click']"
              placement="topLeft"
              @visible-change="isActive = $event"
            >
              <li>
                <a
                  class="footer-link"
                  href="#"
                  @click.prevent
                >
                  Legal
                  <i
                    class="fa-solid fa-caret-right ml-1 transition-transform duration-200"
                    :class="{ '-rotate-90': isActive }"
                  />
                </a>
              </li>
              <template #overlay>
                <a-menu>
                  <a-menu-item>
                    <a href="/privacy">Privacy Policy</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="/terms">Terms of Service</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="/subprocessors">Sub-Processors</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="/cookies">Cookie Policy</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a
                      onclick="javascript:CookieScript.instance.show()"
                      href="javascript:void(0)"
                    >
                      Cookie Preferences
                    </a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { useStore } from '../../api/index.ts';
import { getClient } from '@sentry/browser';
import { onMounted, ref } from 'vue';

const store = useStore();
const date = new Date().getFullYear();
const isActive = ref(false);
const whitelabel = ref(
  store.checkedDomain != null
  && store.checkedDomain.data
  && !store.checkedDomain.domain.endsWith(import.meta.env.VITE_HOSTNAME),
);

onMounted(() => {
  const client = getClient();
  const feedback = client?.getIntegrationByName('Feedback');
  if (feedback) {
    // @ts-expect-error - Feedback integration has attachTo method
    feedback.attachTo(document.querySelector('#report-bug-button'));
  }
});
</script>
